import { useEffect, useState } from 'react';
import { apiListUrgentRiskAlerts } from '../utils/rmsApi';

/**
 * The urgent risk alerts sent for a referral (TDI-701), for the overview flag
 * and the proforma notes. Read once per record; the server decides who may
 * read them (clinical team with access to the record).
 *
 * @returns {{ alerts: Array, loading: boolean, error: boolean }}
 */
export default function useUrgentRiskAlerts(orgId, patientRecordId) {
  const [state, setState] = useState({ alerts: [], loading: true, error: false });

  useEffect(() => {
    if (!orgId || !patientRecordId) {
      setState({ alerts: [], loading: false, error: false });
      return undefined;
    }
    let cancelled = false;
    setState((prev) => ({ ...prev, loading: true, error: false }));
    // Started inside a promise so a synchronous throw lands in the catch
    // below as the error state, never as an uncaught error in the effect.
    Promise.resolve()
      .then(() => apiListUrgentRiskAlerts({ orgId, patientRecordId }))
      .then((data) => {
        if (cancelled) return;
        setState({ alerts: Array.isArray(data?.alerts) ? data.alerts : [], loading: false, error: false });
      })
      .catch((err) => {
        if (cancelled) return;
        // eslint-disable-next-line no-console
        console.warn('[RMS][UrgentRiskAlerts] could not load alerts', err);
        setState({ alerts: [], loading: false, error: true });
      });
    return () => { cancelled = true; };
  }, [orgId, patientRecordId]);

  return state;
}
